//console.log('frontend-events loaded');
import {bottomReached} from './frontend-functions.js';
import {toggleExpandable} from './frontend-functions.js';
import {tabClicked} from './frontend-functions.js';


$('body').on('click', 'a[href="#"]', function (e) {
    e.preventDefault();
});
window.addEventListener('load', () => {
    let scrollWidth = window.innerWidth - document.documentElement.clientWidth;
    let styleTag = document.createElement("style");
    styleTag.innerHTML = `:root { --scroll-width: ${scrollWidth}px; }`;
    document.head.appendChild(styleTag);
});

//window.addEventListener('scroll', (event) => {
//    //console.log('scroll! header should be toggled scrollTop + window height = ', $(window).scrollTop() + $(window).height(), '$(document).height() - 800 =', $(document).height() - 800);
//    if($(window).scrollTop() + $(window).height() >= $(document).height() - 1200 ){
//        //console.log('BOTTOM APPROACHED==============');
//        if ( $('.site-wrapper').hasClass('vgong') ) {
//            bottomReached_vgong();            
//        } else {
//            bottomReached();            
//        }
//    }
//});


const sentinel = document.createElement('div');
sentinel.style.height = '1px';
sentinel.className = 'page-loader';
document.body.appendChild(sentinel);

const observer = new IntersectionObserver(entries => {
    if (entries[0].isIntersecting) {
        if ($('.site-wrapper').hasClass('vgong')) {
            bottomReached_vgong();
        } else {
            bottomReached();
        }
    }
}, { rootMargin: '1200px' });

observer.observe(sentinel);



//Toggle collapsible - show more btn
$('body').on('click', '.toggle-expandable', function (e) {
    e.preventDefault();
    console.log('toggled event triggered', $(this).attr('data-id') );
    toggleExpandable( $(this).attr('data-id') );
});


//Common dialog behaviour
//Close / close and clear content
$('body').on('click', '.modal .close-button', function (e) {
    e.preventDefault();
    if($(this).hasClass('clear')){
        $(this).closest('.modal').find('.modal-body').html('');
    }
   // hide modal
   if ( $(this).closest('.modal').is('dialog') ) {
       $(this).closest('.modal')[0].close();
   } else {
       $(this).closest('.modal').toggleClass('closed open');
   }
   
});

// Open dialog
$('body').on('click', '.dialog-trigger', function (e) {
    //console.log('dialog-triggerrrrrrrrrrrrred', $(this).attr('data-id'));
    e.preventDefault();
    let dialogId = $(this).attr('data-id');
    $('dialog#' + dialogId)[0].showModal();
});


// Prevent default does not work for touchstart events, when the triggering element is inside a dialog
$('body').on('click', '.ham-trigger', function (e) {
    //console.log('ham-triggerrrrrrrrrrrrred', $(this).attr('data-id'));
    e.preventDefault();
    let hamId = $(this).attr('data-id');
    $('#' + hamId).toggleClass('closed open');
});

$('body').on('click', '.hamburger-backdrop', function (e) {
    e.preventDefault();
    $(this).siblings('.modal').toggleClass('closed open');
});

//BREAKING NEWS FASHA
$('body').on('click', '.breaking-news-wrap .close-button', function (e) {
    e.preventDefault();    
   // hide breaking news
    $(this).closest('.breaking-news-wrap').addClass('closed');   
});

//Tabs (livescore formation-lists)
$('body').on('click', '.tab:not(.active)', function (e) {
    e.preventDefault();
    //console.log('hub tab clicked!!!!   ID = ', $(this).attr('id'));
    let tabWrapperId = $(this).closest('.tabs-wrap').attr('id');
    //check for screen version
    let hideversion = 'hidden';
    if( $(this).closest('.tabs.hidden-mb').length > 0 ) {
        hideversion = 'hidden-dt';
    };
    if( $(this).closest('.tabs.hidden-dt').length > 0 ) {
        hideversion = 'hidden-mb';
    };    
    //identifier - data-id, content may be wrapped in several containers
    let identifier = $(this).attr('id');
    
    tabClicked( tabWrapperId, hideversion, identifier );
});

$('body').on('click', '.trigger-onesignal', function (e) {
    e.preventDefault();
    $('.onesignal-bell-launcher-button').trigger('click');
});